import Heading from './../components/Heading';
import SmallHeading from './../components/SmallHeading';
import BlogCard from './../components/BlogCard';
import Legal from './../assets/pexels/legaltech.jpg'
import Compliance from './../assets/pexels/compliance.jpg'
import Property from './../assets/pexels/copyright.jpg'

function BlogSection() {
  return (
    <section id="blog" className='pb-10'>
    <SmallHeading name="Featured Blog/Resources" tstyle="text-center my-1 pt-10"/>
    <Heading name="Read the latest & greatest in the law world." tstyle="text-center my-1"/>
    {/* <div className='mt-4 px-10' >
      <DetailsHeading 
      name="What Our Clients Say" 
      tstyle="my-1"
      />

    </div> */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10 mx-10">
        <BlogCard 
          heading="The Importance of Compliance in Growing Businesses"
          image={Compliance}
          link="/blogs/1"
        />
        <BlogCard 
          heading="How to Protect Your Intellectual Property"
          image={Property}
          link="/blogs/2"
        />
        <BlogCard 
          heading="Legal Tech: AI-Driven Solutions in Law"
          image={Legal}
          link="/blogs/3"
        />     
    </div>
    </section>
  );
}

export default BlogSection;
